<template>
    <div class="table-pager">
        <a href="javascript: void 0" @click="customPageChange(pageIndex - 1)" :disabled="pageIndex<=0" class="pager-previous">
            <font-awesome-icon :icon="['fas','angle-left']" size="2x"/>
        </a>
        <div class="pager-total">
            <span v-i18n="'DISPLAY_RECORDS'" />
            <strong>{{pageSize * pageIndex + 1}}-{{Math.min(pageSize * (pageIndex + 1), totalRecords)}} </strong>
            <span v-i18n="'OF'" />
            <strong>{{totalRecords}}</strong>
        </div>
        <a href="javascript: void 0" @click="customPageChange(pageIndex + 1)" :disabled="pageIndex>=totalPages" class="pager-next">
            <font-awesome-icon :icon="['fas','angle-right']" size="2x"/>
        </a>
    </div>
</template>
<script>
export default {
    props: {
        totalPages: {
            type: Number
        },
        pageIndex: {
            type: Number
        },
        pageSize: {
            type: Number
        },
        totalRecords: {
            type: Number
        },
        pageChanged: {
            type: Function,
        },
        perPageChanged: {
            type: Function,
        }
    },
    methods: {
        customPageChange(customCurrentPage) {
            this.pageChanged({currentPage: customCurrentPage});
        },
        customPerPageChange(customPerPage) {
            this.perPageChanged({currentPerPage: customPerPage});
        }
    }
}
</script>